<template>
  <b-modal v-model="show" size="md" centered header-bg-variant="primary" hide-footer :title="`${modalData.PaymentDetail.Name} Attributes`" @hide="closeModal()">
    <div class="d-block">
      <b-row>
        <b-col sm="12" v-if="show">
          <b-row>
            <b-col sm="12">
              <p-input v-model="form.attributes" :disabled="!accessRight" label="Payment Attributes" name="attributes" :handler="$v" :formData="form" type="textarea" />
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" >
          <b-button :disabled="!accessRight" variant="success" @click="save()">Save</b-button>
          <b-button variant="outline-danger" @click="closeModal()">Cancel</b-button>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import { PInput } from '../../../../components'
import { Events } from '../../../../events.js'
import VueNotifications from 'vue-notifications'
export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    modalData: {
      type: Object,
      default: {}
    },
    accessRight: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      form: {
        attributes: ''
      }
    }
  },
  validations: {
    form: {
      attributes: {
      }
    }
  },
  components: {
    PInput
  },
  computed: {
    show: {
      get: function () {
        return this.showModal
      },
      set: function () {
        return this.showModal
      }
    }
  },
  created () {
    this.form.attributes = this.modalData.Attributes || this.modalData.PaymentDetail.Attributes
  },
  methods: {
    closeModal () {
      this.$emit('closeModal')
    },
    async save () {
      try {
        if (this.$v.form.$error) {
          return true
        }
        const payload = {
          paymentId: this.modalData.PaymentDetail.Id,
          levelId: this.modalData.Id,
          attributes: this.form.attributes
        }
        await this.$http.post(`${this.API_ENDPOINT}/payment/levelmap/attributes/update`, payload, { headers: { 'Content-Type': 'application/json' } })
        Events.$emit('loader')
        this.closeModal()
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Payment Attributes updated successfully.')
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/payment/viplevel/PaymentOption/AttributesModal.vue